"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _react2 = _interopRequireDefault(require("@fullcalendar/react"));

var _daygrid = _interopRequireDefault(require("@fullcalendar/daygrid"));

var _timegrid = _interopRequireDefault(require("@fullcalendar/timegrid"));

var _interaction = _interopRequireDefault(require("@fullcalendar/interaction"));

var _list = _interopRequireDefault(require("@fullcalendar/list"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _AppointmentModal = _interopRequireDefault(require("./AppointmentModal"));

var _appointments = require("../../redux/appointments/appointments.types");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _AppointmentConstant = require("../../constant/AppointmentConstant");

var _reselect = require("reselect");

var _moment = _interopRequireDefault(require("moment"));

var _availability = require("../../redux/availabilty/availability.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  confirm
} = _modal.default;
const defaultState = {
  selectedAppointment: undefined,
  events: [],
  loading: false
};

class AppointmentCalendar extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = (0, _lodash.clone)(defaultState);
    this.calendar = /*#__PURE__*/_react.default.createRef();

    this.selectAppointment = id => {
      const {
        studyId,
        history
      } = this.props;
      history.push(`/study/${studyId}/appointments/appointments/edit/${id}`);
    };

    this.handleDateSelect = selectInfo => {
      const selectedAppointment = {
        startDate: selectInfo.start,
        endDate: selectInfo.end
      };
      this.setState({
        selectedAppointment,
        removeEvent: () => selectInfo.view.calendar.unselect()
      });
      const {
        history,
        studyId
      } = this.props;
      history.push(`/study/${studyId}/appointments/appointments/new`);
    };

    this.handleEventClick = clickInfo => {
      this.selectAppointment(clickInfo.event.id);
      this.setState({
        removeEvent: () => clickInfo.event.remove()
      });
    };

    this.saveAppointment = appointmentToSave => {
      const {
        history,
        studyId,
        appointments,
        defaultAppointmentLength,
        createAppointment,
        updateAppointment
      } = this.props;
      const startMoment = (0, _moment.default)(appointmentToSave.startDate),
            endMoment = (0, _moment.default)(appointmentToSave.endDate);
      const beforeSave = (0, _lodash.find)(appointments, a => a.id === (appointmentToSave === null || appointmentToSave === void 0 ? void 0 : appointmentToSave.id));
      const timesHaveChanged = beforeSave && (!startMoment.isSame(beforeSave.startDate) || !endMoment.isSame(beforeSave.endDate));
      const diffMinutes = endMoment.diff(startMoment, 'minutes');
      const showNonDefaultMeetingLengthConfirmation = timesHaveChanged && diffMinutes !== defaultAppointmentLength;

      const doSave = () => {
        try {
          if (appointmentToSave.id) {
            updateAppointment(appointmentToSave);
          } else {
            createAppointment(appointmentToSave);
          }
        } finally {
          if (this.state.removeEvent) {
            this.state.removeEvent();
          }

          history.push(`/study/${studyId}/appointments/appointments`);
        }
      };

      if (showNonDefaultMeetingLengthConfirmation) {
        confirm({
          title: `This appointments duration is ${diffMinutes} minutes and not the default ${defaultAppointmentLength} minutes. Do you want to continue?`,
          okText: 'Save',
          okType: 'primary',
          onOk: doSave
        });
      } else {
        doSave();
      }
    };
    /**
     *  handleEventDrop occurs when an existing event is dragged to a new datetime
     *  or when an event is dragged onto the calendar from an external component.
     *  Currently, the second case should never happen, so when we save an event in
     *  this method we'll set the parameter isNew to false.
     */


    this.handleEventDrop = changeInfo => {
      const {
        appointments
      } = this.props;
      const {
        event
      } = changeInfo;
      const appointmentId = event._def.publicId;
      const existingAppointment = (0, _lodash.find)(appointments, a => a.id === appointmentId);

      if (existingAppointment) {
        const newStart = (0, _moment.default)(event.start),
              newEnd = (0, _moment.default)(event.end);
        const {
          id,
          title,
          participantId,
          adminId,
          notes,
          adminNotes,
          address,
          phoneNumber
        } = existingAppointment;
        const newOrUpdateAppointment = {
          id,
          title,
          startDate: newStart.toDate(),
          endDate: newEnd.toDate(),
          participantId,
          adminId,
          notes,
          adminNotes,
          address,
          phoneNumber
        };
        confirm({
          title: `Are you sure you want to update this appointment?`,
          okText: 'Save',
          okType: 'primary',
          onOk: () => {
            this.saveAppointment(newOrUpdateAppointment);
          },
          onCancel: () => {
            changeInfo.revert();
          }
        });
      }
    };
    /**
     *  handleEventResize occurs when an existing event is resized to a new start
     *  or end time.
     */


    this.handleEventResize = changeInfo => {
      const {
        appointments
      } = this.props;
      const {
        event
      } = changeInfo;
      const appointmentId = event._def.publicId;
      const existingAppointment = (0, _lodash.find)(appointments, a => a.id === appointmentId);

      if (existingAppointment) {
        const newStart = (0, _moment.default)(event.start),
              newEnd = (0, _moment.default)(event.end);
        const {
          id,
          title,
          participantId,
          adminId,
          notes,
          adminNotes,
          address,
          phoneNumber
        } = existingAppointment;
        const newOrUpdateAppointment = {
          id,
          title,
          startDate: newStart.toDate(),
          endDate: newEnd.toDate(),
          participantId,
          adminId,
          notes,
          adminNotes,
          address,
          phoneNumber
        };
        confirm({
          title: `Are you sure you want to update this appointment?`,
          okText: 'Save',
          okType: 'primary',
          onOk: () => {
            this.saveAppointment(newOrUpdateAppointment);
          },
          onCancel: () => {
            changeInfo.revert();
          }
        });
      }
    };

    this.mapAppointmentTypeToEventInput = appointment => {
      var _a, _b;

      const {
        id,
        title,
        startDate,
        endDate
      } = appointment;
      return {
        id,
        title,
        start: startDate,
        end: endDate,
        allDay: false,
        color: !appointment.adminId ? '#ff4d4f' : undefined,
        extendedProps: { ...appointment,
          participantId: (_a = appointment.participantId) === null || _a === void 0 ? void 0 : _a.toString(),
          adminId: (_b = appointment.adminId) === null || _b === void 0 ? void 0 : _b.toString()
        }
      };
    };

    this.refreshData = () => {
      var _a, _b, _c;

      this.setState({
        loading: true
      }); // Get appointment data

      const getAppointmentsQueryParameters = {
        includeDeleted: false
      };
      this.props.getAppointments(getAppointmentsQueryParameters); // Get availability data

      const startMoment = (0, _moment.default)((_b = (_a = this.calendar) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getApi().getCurrentData().dateProfile.currentRange.start);
      const getAvailabilitiesQueryParameters = {
        startDate: startMoment.toDate()
      };
      this.props.getAvailabilities(getAvailabilitiesQueryParameters);
      let events = (0, _lodash.map)(this.props.appointments, a => {
        return {
          id: a.id,
          title: a.title,
          start: a.startDate,
          end: a.endDate,
          extendedProps: {
            type: _AppointmentConstant.APPOINTMENT_TYPE
          }
        };
      });

      if ((_c = this.props.availabilities) === null || _c === void 0 ? void 0 : _c.length) {
        events = events.concat(this.props.availabilities.map(a => {
          return {
            id: a.id,
            start: a.startDate,
            end: a.endDate,
            display: 'background',
            backgroundColor: '#FF7785',
            extendedProps: {
              type: _AppointmentConstant.AVAILABILITY_TYPE
            }
          };
        }));
      }

      if (events && events.length) {
        this.setState({
          events
        });
      }

      setTimeout(() => {
        this.setState({
          loading: false
        });
      }, 500);
    };
  }

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      requestedAppointmentTab,
      selectedAppointmentId,
      appointments,
      availabilities
    } = this.props;
    const {
      events
    } = this.state;

    if (requestedAppointmentTab === 'appointments' && selectedAppointmentId && appointments) {
      const selectedAppointment = (0, _lodash.find)(appointments, a => a.id === selectedAppointmentId);

      if (!prevState.selectedAppointment && selectedAppointment || !(0, _lodash.isEqual)(selectedAppointment, prevState.selectedAppointment)) {
        this.setState({
          selectedAppointment
        });
      }
    } else if (!(0, _lodash.isEmpty)(prevProps.selectedAppointmentId) && (0, _lodash.isEmpty)(selectedAppointmentId)) {
      this.setState({
        selectedAppointment: undefined
      });
    }

    if ((availabilities === null || availabilities === void 0 ? void 0 : availabilities.length) && !(0, _lodash.isEqual)(prevProps.availabilities, availabilities)) {
      const updatedEvents = events // Removes old availability data
      .filter(e => {
        var _a;

        return ((_a = e.extendedProps) === null || _a === void 0 ? void 0 : _a.type) !== _AppointmentConstant.AVAILABILITY_TYPE;
      }) // Maps new data to events
      .concat(availabilities.map(a => {
        return {
          id: a.id,
          start: a.startDate,
          end: a.endDate,
          display: 'background',
          backgroundColor: '#FF7785',
          extendedProps: {
            type: _AppointmentConstant.AVAILABILITY_TYPE
          }
        };
      }));
      this.setState({
        events: updatedEvents
      });
    }

    if ((appointments === null || appointments === void 0 ? void 0 : appointments.length) && !(0, _lodash.isEqual)(prevProps.appointments, appointments)) {
      const updatedEvents = events // Removes old appointment data
      .filter(e => {
        var _a;

        return ((_a = e.extendedProps) === null || _a === void 0 ? void 0 : _a.type) !== _AppointmentConstant.APPOINTMENT_TYPE;
      }) // Maps new data to events
      .concat(appointments.map(a => {
        return {
          id: a.id,
          title: a.title,
          start: a.startDate,
          end: a.endDate,
          extendedProps: {
            type: _AppointmentConstant.APPOINTMENT_TYPE
          }
        };
      }));
      this.setState({
        events: updatedEvents
      });
    }
  }

  render() {
    const {
      selectedAppointment,
      events,
      removeEvent,
      loading
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, selectedAppointment && /*#__PURE__*/_react.default.createElement(_AppointmentModal.default, {
      selectedAppointment: selectedAppointment,
      saveAppointment: this.saveAppointment,
      removeEvent: removeEvent
    }), /*#__PURE__*/_react.default.createElement(_react2.default, {
      ref: this.calendar,
      unselectAuto: false,
      plugins: [_daygrid.default, _timegrid.default, _interaction.default, _list.default],
      customButtons: {
        refresh: {
          text: loading ? 'loading...' : 'refresh',
          click: loading ? undefined : this.refreshData
        }
      },
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'refresh dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      },
      initialView: "dayGridMonth",
      events: events,
      editable: true,
      selectable: true,
      selectMirror: true,
      dayMaxEvents: true,
      weekends: true,
      select: this.handleDateSelect,
      eventClick: this.handleEventClick,
      eventDrop: this.handleEventDrop,
      eventResize: this.handleEventResize
    }));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  selectedAppointmentId: selectors.getUrlNewOrEditId,
  studyId: selectors.getRequestedStudyId,
  requestedAppointmentTab: selectors.getUrlRouteSubpage,
  appointments: selectors.getAppointments,
  defaultAppointmentLength: selectors.getDefaultAppointmentLength,
  availabilities: selectors.getAvailabilities
});

const mapDispatchToProps = dispatch => {
  return {
    getAppointments: params => dispatch(_appointments.getAppointmentsAsync.request(params)),
    getAvailabilities: params => dispatch(_availability.getAvailabilitiesAsync.request(params)),
    createAppointment: appt => dispatch(_appointments.createAppointmentAsync.request(appt)),
    updateAppointment: appt => dispatch(_appointments.updateAppointmentAsync.request(appt))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouterDom.withRouter)(AppointmentCalendar));

exports.default = _default;